module.exports = __webpack_public_path__ + "static/media/shuttleBanner1.39c3d42c.png";